module.exports = __webpack_public_path__ + "static/media/lemanbleu-tv.1d0e80fe.png";